<template>
<div class="page-sns-box">
  <div class="sns-common-box">
    <ul class="sns-common-list">
      <li class="sns-common-list__item">
          <a :href="'https://social-plugins.line.me/lineit/share?' + encodeURI(pageUrl)" class="btn-sns btn-sns--line ir" target="_blank">Lineで送る</a>
      </li>
      <li class="sns-common-list__item">
          <a :href="'http://twitter.com/intent/tweet?text=動画配信サービス一覧+%7C+aukana(アウカナ)by動画配信サービス比較情報.com ' + encodeURI(pageUrl)" onclick="window.open(this.href, 'Gwindow', 'width=650, height=450, menubar=no, toolbar=no, scrollbars=yes'); return false;" class="btn-sns btn-sns--tw ir">Twitter</a>
      </li>
      <li class="sns-common-list__item">
          <a :href="'http://www.facebook.com/share.php?u=' + encodeURI(pageUrl)" rel="”nofollow”" onclick="window.open(encodeURI(decodeURI(this.href)),'fbwindow','width=550, height=450, personalbar=0, toolbar=0, scrollbars=1'); return false;" class="btn-sns btn-sns--fb ir">Facebook</a>
      </li>
      <li class="sns-common-list__item">
          <a :href="'http://b.hatena.ne.jp/add?mode=confirm&amp;title=' + pageTitle + ' aukana(アウカナ)by動画配信サービス比較情報.com&amp;url=' + encodeURI(pageUrl)" onclick="window.open(this.href, 'Gwindow', 'width=650, height=450, menubar=no, toolbar=no, scrollbars=yes'); return false;" class="btn-sns btn-sns--hatena ir">はてなブックマーク</a>
      </li>
    </ul>
  </div>
</div>
</template>

<script>
export default {
  data() {
    return {
      pageUrl: location.href,
      pageTitle: document.title
    }
  }
}
</script>